<template>
  <div>
		<div>
		<h4>Multiple Case Reassignment <v-icon
        color="rgba(21, 102, 124, 0.9)"
        @click="clearMultiCase"
        style="float: right"
        >mdi-close</v-icon
      ></h4>
	</div>
		<!-- unassigend section -->
		<div v-if="Object.keys(this.unassignedList).length  > 0">
		<v-divider></v-divider>
			<div class="changeArea" @click="toggleUnassignedArea">
			<h5> Unassigned</h5>
			<p id="duidList">
				<span  v-for="item in unassignedList" :key="item.feature.properties.DUID">{{ item.feature.properties.DUID }}, </span>
			</p>
			<p v-if="!unassignedAreaSaved && !unassignedArea" align="center"><v-icon color="#f0ad4e">mdi-circle-outline</v-icon>Click To Make Changes</p>
			<p v-if="unassignedAreaSaved && !unassignedArea" align="center"><v-icon color="green">mdi-checkbox-marked-circle-outline</v-icon>Changes Saved</p>
		</div>
		<div v-if="unassignedArea">
			<v-select
      :items="unassignedItems"
			item-text="regular"
			item-value="capitalized"
      v-model="newUnassignedStatus"
      label="New Status"
      required
			density="compact"
    ></v-select>
    <v-select v-if="newUnassignedStatus == 'ASSIGNED'"
      :items="staffIds"
      v-model="newUnassignedStaffId"
      label="New Assigned Staff"
      required
			density="compact"
    ></v-select>
    <v-textarea
      v-model="newUnassignedComment"
      label="Comments"
      rows="2"
      row-height="20"
      outlined
			density="compact"
    ></v-textarea>
		<p class="list-group-item-text" align="right">
			<v-btn
        small
				id="cancelButton"
				@click="cancelUnassignedArea"
      >
        cancle
      </v-btn>
			<v-btn
			id="saveButton"
        small
				@click="saveUnassignedArea"
				:disabled="!newUnassignedStatus"
      >
        save
      </v-btn>
    </p>
		</div>
	</div>
	<!-- assigned section -->
	<div v-if="Object.keys(this.assignedList).length  > 0">
		<v-divider></v-divider>
		<div class="changeArea" @click="toggleAssignedArea">
		<h5> Assigned</h5>
		<p id="duidList"><span  v-for="item in this.assignedList" :key="item.feature.properties.DUID">{{ item.feature.properties.DUID }}, </span>
		</p>
		</div>
		<p v-if="!assignedAreaSaved && !assignedArea" align="center"><v-icon color="#f0ad4e">mdi-circle-outline</v-icon>No Changes Made</p>
		<p v-if="assignedAreaSaved && !assignedArea" align="center"><v-icon color="green">mdi-checkbox-marked-circle-outline</v-icon>Changes Saved</p>
		<div v-if="assignedArea">
		<v-select
      :items="assignedItems"
			item-text="regular"
			item-value="capitalized"
      v-model="newAssignedStatus"
      label="New Status"
      required
			density="compact"
    ></v-select>
		<v-select v-if="newAssignedStatus === 'ASSIGNED'"
      :items="staffIds"
      v-model="newAssignedStaffId"
      label="New Assigned Staff"
      required
			density="compact"
    ></v-select>
		<v-textarea
      v-model="newAssignedComment"
      label="Comments"
      rows="2"
      row-height="20"
      outlined
			density="compact"
    ></v-textarea>
		<p class="list-group-item-text" align="right">
			<v-btn
        small
				id="cancelButton"
				@click="cancelAssignedArea"
      >
        cancel
      </v-btn>
			<v-btn
			id="saveButton"
        small
				@click="saveAssignedArea"
				:disabled="!newAssignedStatus"
      >
        save
      </v-btn>
    </p>
	</div>
	</div>
	<!-- not reviewed section -->
	<div v-if="Object.keys(this.notReviewedList).length  > 0">
		<v-divider></v-divider>
		<div class="changeArea" @click="toggleNotReviewedArea">
		<h5> Not Reviewed</h5>
		<p id="duidList"><span  v-for="item in this.notReviewedList" :key="item.feature.properties.DUID">{{ item.feature.properties.DUID }}, </span>
		</p>
	</div>
	<p v-if="!notReviewedAreaSaved && !notReviewedArea" align="center"><v-icon color="#f0ad4e">mdi-circle-outline</v-icon>No Changes Made</p>
		<p v-if="notReviewedAreaSaved && !notReviewedArea" align="center"><v-icon color="green">mdi-checkbox-marked-circle-outline</v-icon>Changes Saved</p>
		<div v-if="notReviewedArea">
    <v-select
      :items="notReviewedItems"
			item-text="regular"
			item-value="capitalized"
      v-model="newNotReviewedStatus"
      label="New Status"
      required
    ></v-select>

    <v-select v-if="newNotReviewedStatus === 'ASSIGNED'"
      :items="staffIds"
      v-model="newNotReviewedStaffId"
      label="New Assigned Staff"
      required
    ></v-select>

    <v-textarea
      v-model="newNotReviewedComment"
      label="Comments"
      rows="2"
      row-height="20"
      outlined
    ></v-textarea>
		<p class="list-group-item-text" align="right">
			<v-btn
        small
				id="cancelButton"
				@click="cancelNotReviewedArea"
      >
        cancel
      </v-btn>
			<v-btn
			id="saveButton"
        small
				@click="saveNotReviewedArea"
				:disabled="!newNotReviewedStatus"
      >
        save
      </v-btn>
    </p>

	</div>
		</div>
		<!-- Confirmed -->
		<div v-if="Object.keys(this.confirmedList).length  > 0">
		<v-divider></v-divider>
		<h5> Confirmed</h5>
		<p id="duidList"><span  v-for="item in this.confirmedList" :key="item.feature.properties.DUID">{{ item.feature.properties.DUID }}, </span>
		</p>
		<p align="center"><v-icon color="red">mdi-close-circle-outline</v-icon>Cannot Change</p>
	</div>
	<v-divider></v-divider>
	<v-btn
				id="submitButton"
				:disabled="!unassignedAreaSaved && !assignedAreaSaved && !notReviewedAreaSaved"
        small
        @click="
          updateCaseBatch();
          $emit('close');
          dialog = false;
        "
      >
        Submit
      </v-btn>
		</div>
</template>
<script>

import { caseAssignmentService } from "../services/caseAssignmentService";
import { STORE_CONSTANTS } from "@/common/store.constants";

import { mapGetters } from "vuex";

export default {
  name: "MultipleStatusPopUp",
  props: {
    studyCode: String,
    record: Object,
    assignStaffId: String,
    multipleRecords: Object,
    region: String,
  },
  data: () => ({
    STORE_CONSTANTS,
    newUnassignedStaffId: null,
    oldStaffId: null,
    unassignedItems: [
      { regular: "Assigned", capitalized: "ASSIGNED" },
      { regular: "Unassigned", capitalized: "UNASSIGNED" },
    ],
    notReviewedItems: [
      { regular: "Unassigned", capitalized: "UNASSIGNED" },
      { regular: "Assigned", capitalized: "ASSIGNED" },
			{ regular: "Notreviewed", capitalized: "NOTREVIEWED" },
    ],
    assignedItems: [
      { regular: "Unassigned", capitalized: "UNASSIGNED" },
      { regular: "Assigned", capitalized: "ASSIGNED" },
    ],
    newUnassignedStatus: null,
    newUnassignedComment: "",
    unassignedList: null,
    confirmedList: null,
    assignedList: null,
    notReviewedList: null,
    comment: null,
    newAssignedStatus: null,
    newAssignedStaffId: null,
    newAssignedComment: null,
    newNotReviewedComment: null,
    newNotReviewedStatus: null,
    newNotReviewedStaffId: null,
    unassignedArea: false,
    unassignedAreaSaved: false,
    assignedArea: false,
    assignedAreaSaved: false,
    notReviewedArea: false,
    notReviewedAreaSaved: false,
    newUnassignedCasesArray: [],
    newAssignedCasesArray: [],
    newNotReviewedCasesArray: [],
    allNewCaseObjected: [],
  }),
  watch: {
    multipleRecords: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.setGroups();
      }
    },
  },
  computed: {
    staffIds () {
      const regionStaffIds = this.getRegionStaff;
      // console.log('Staff IDs:');
      // console.log(regionStaffIds);
      return regionStaffIds;
    },
    ...mapGetters("assignment", [
        "getRegionStaff"
    ]),
  },
  updated() {
    if (this.record) {
      this.startingStatus = this.record.assignStatus;
      this.startingStaff = this.record.staffId;
    }
  },
  methods: {
    setGroups() {
      console.log("setGroups this.multipleRecords", this.multipleRecords);
      let recordsAsArray = Object.entries(this.multipleRecords);
      const unassignedFiltered = recordsAsArray.filter(
        ([key, value]) => value.feature.properties.Status === "UNASSIGNED"
      );
      this.unassignedList = Object.fromEntries(unassignedFiltered);
      const confirmedFiltered = recordsAsArray.filter(
        ([key, value]) => value.feature.properties.Status === "CONFIRMED"
      );
      this.confirmedList = Object.fromEntries(confirmedFiltered);
      const assignedFiltered = recordsAsArray.filter(
        ([key, value]) => value.feature.properties.Status === "ASSIGNED"
      );
      this.assignedList = Object.fromEntries(assignedFiltered);
      const notReviewedFiltered = recordsAsArray.filter(
        ([key, value]) => value.feature.properties.Status === "NOTREVIEWED"
      );
      this.notReviewedList = Object.fromEntries(notReviewedFiltered);
    },
    updateUnassignedCases() {
      const me = this;
      if (me.unassignedList) {
        let arrayNewCaseObjects = [];
        for (let oneRecord in me.unassignedList) {
          const rec = me.unassignedList[oneRecord];
          let newStaffIdTemp = rec.feature.properties.StaffId;
          if (me.newUnassignedStatus === "UNASSIGNED") {
            newStaffIdTemp = "Unassigned";
          }
          if (
            me.newUnassignedStatus !== "UNASSIGNED" &&
            me.newUnassignedStaffId
          ) {
            newStaffIdTemp = me.newUnassignedStaffId;
          }

          let updateCaseObject = {
            caseUuid: rec.feature.properties.CaseUUID,
            assignStatus: me.newUnassignedStatus,
            newStaffId: newStaffIdTemp,
            comment: me.newUnassignedComment || "",
            oldStaffId: rec.feature.properties.StaffId,
          };
          arrayNewCaseObjects.push(updateCaseObject);
        }
        this.newUnassignedCasesArray = arrayNewCaseObjects;
      }
    },
    updateAssignedCases() {
      const me = this;
      if (me.assignedList) {
        let arrayNewCaseObjects = [];
        for (let oneRecord in me.assignedList) {
          const rec = this.assignedList[oneRecord];
          let newStaffIdTemp = rec.feature.properties.StaffId;
          if (me.newAssignedStatus === "UNASSIGNED") {
            newStaffIdTemp = "Unassigned";
          }
          if (me.newAssignedStaffId && me.newAssignedStaffId !== "UNASSIGNED") {
            newStaffIdTemp = me.newAssignedStaffId;
          }
          let updateCaseObject = {
            caseUuid: rec.feature.properties.CaseUUID,
            assignStatus: me.newAssignedStatus,
            newStaffId: newStaffIdTemp,
            comment: this.newAssignedComment || "",
            oldStaffId: rec.feature.properties.StaffId,
          };
          arrayNewCaseObjects.push(updateCaseObject);
        }
        this.newAssignedCasesArray = arrayNewCaseObjects;
      }
    },
    updateNotReviewedCases() {
      const me = this;
      if (me.notReviewedList) {
        let arrayNewCaseObjects = [];
        for (let oneRecord in me.notReviewedList) {
          const rec = me.notReviewedList[oneRecord];
          let newStaffIdTemp = rec.feature.properties.StafId;
          if (me.newNotReviewedStatus === "UNASSIGNED") {
            newStaffIdTemp = "Unassigned";
          }
          if (
            me.newNotReviewedStatus &&
            me.newNotReviewedStatus !== "UNASSIGNED"
          ) {
            newStaffIdTemp = me.newNotReviewedStaffId;
          }
          let updateCaseObject = {
            caseUuid: rec.feature.properties.CaseUUID,
            assignStatus: me.newNotReviewedStatus,
            newStaffId: newStaffIdTemp,
            comment: me.newNotReviewedComment || "",
            oldStaffId: rec.feature.properties.StaffId,
          };
          arrayNewCaseObjects.push(updateCaseObject);
        }
        me.newNotReviewedCasesArray = arrayNewCaseObjects;
        console.log(
          "this.newNotReviewedCaseseArray",
          me.newNotReviewedCasesArray
        );
      }
    },
    updateCaseBatch() {
      const me = this;
      const arrayNewCaseObjects = this.newUnassignedCasesArray.concat(
        this.newAssignedCasesArray,
        this.newNotReviewedCasesArray
      );
      console.log("arrayNewCaseObjects", arrayNewCaseObjects);
      // me.newAssignedCasesArray = [];
      // me.newUnassignedCasesArray = [];
      // me.newNotReviewedCasesArray = [];
      this.clearMultiCase();
      me.$store.commit(this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING, { data: true });
      caseAssignmentService
        .updateCaseBatch(me.studyCode, arrayNewCaseObjects, me.region)
        .then(function (response) {
          if (response && response.data) {
            me.$emit("refreshData", response.data);
          }
          me.comment = "";
        })
        .catch(function (e) {
          console.log(e);
          me.$store.commit(this.STORE_CONSTANTS.ASSIGNMENT.MUTATIONS.SET_IS_LOADING, { data: false });
          me.comment = "";
        });
    },
    toggleUnassignedArea() {
      this.unassignedArea = !this.unassignedArea;
    },
    saveUnassignedArea() {
      this.updateUnassignedCases();
      this.unassignedAreaSaved = true;
      this.toggleUnassignedArea();
    },
    cancelUnassignedArea() {
      this.unassignedAreaSaved = false;
      this.newUnassignedStatus = null;
      this.newUnassignedStaffId = null;
      this.newUnassignedComment = null;
      this.toggleUnassignedArea();
    },
    toggleAssignedArea() {
      this.assignedArea = !this.assignedArea;
    },
    saveAssignedArea() {
      this.updateAssignedCases();
      this.assignedAreaSaved = true;
      this.toggleAssignedArea();
    },
    cancelAssignedArea() {
      this.assignedAreaSaved = false;
      this.newAssignedStatus = null;
      this.newAssignedStaffId = null;
      this.newAssignedComment = null;
      this.toggleAssignedArea();
    },
    toggleNotReviewedArea() {
      this.notReviewedArea = !this.notReviewedArea;
    },
    saveNotReviewedArea() {
      this.updateNotReviewedCases();
      this.notReviewedAreaSaved = true;
      this.toggleNotReviewedArea();
    },
    cancelNotReviewedArea() {
      this.notReviewedAreaSaved = false;
      this.newNotReviewedStatus = null;
      this.newNotReviewedStaffId = null;
      this.newNotReviewedComment = null;
      this.toggleNotReviewedArea();
    },
    clearMultiCase() {
      this.$emit("close");
      this.unassignedAreaSaved = false;
      this.newUnassignedStatus = null;
      this.newUnassignedStaffId = null;
      this.newUnassignedComment = null;
      this.assignedAreaSaved = false;
      this.newAssignedStatus = null;
      this.newAssignedStaffId = null;
      this.newAssignedComment = null;
      this.notReviewedAreaSaved = false;
      this.newNotReviewedStatus = null;
      this.newNotReviewedStaffId = null;
      this.newNotReviewedComment = null;
      this.newAssignedCasesArray = [];
      this.newUnassignedCasesArray = [];
      this.newNotReviewedCasesArray = [];
    },
  },
};
</script>

<style scoped>
.list-group-item-text {
  margin-bottom: 0;
  line-height: 1;
}

#cancelButton {
  background-color: #f0ad4e;
  color: white;
}

#saveButton {
  background-color: green;
  color: white;
}

#submitButton {
  background-color: #265a88;
  color: white;
}
#duidList {
  height: 45px;
  overflow-y: auto;
  margin-bottom: 0px;
}
.v-tooltip__content {
  background-color: rgb(21, 72, 124) !important;
  opacity: 1 !important;
}

.changeArea:hover {
  background-color: rgb(21, 72, 124, 0.1);
  cursor: pointer;
  margin: 10px 10px;
}
.theme--light.v-divider {
  border-color: black;
}
</style>
